import { ChevronDownIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { forwardRef } from 'react';

interface TriggerButtonProps {
  labelPrefix: string;
  displayValue: string;
  isFullyRounded: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const TriggerButton = forwardRef<HTMLButtonElement, TriggerButtonProps>(
  ({ labelPrefix, displayValue, isFullyRounded, onClick, disabled }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        disabled={disabled}
        className={clsx(
          'focus:border-fiona relative inline-flex items-center justify-center gap-x-2 border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 focus:relative focus:z-10 focus:shadow-[0_0_0_2px_theme(colors.fiona)] focus:outline-none',
          isFullyRounded ? 'rounded-md' : 'rounded-l-md',
          disabled
            ? 'cursor-not-allowed opacity-50'
            : 'hover:bg-gray-50',
        )}
        onClick={onClick}
      >
        <span>
          <span className="font-normal">{labelPrefix}</span>
          <span className="font-bold">{` ${displayValue}`}</span>
        </span>
        <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5 text-gray-400" aria-hidden="true" />
      </button>
    );
  },
);

TriggerButton.displayName = 'TriggerButton';

